<template>
  <div class="base-article-text-row md:max-w-xl lg:max-w-xl content-block mb-8 md:mb-16" :class="{ 'mx-auto': this.$props.center }">
    <div v-html="row.text" :class="[textSizes, indentation]" class="flex-1 body"></div>
  </div>
</template>

<script>
export default {
  name: 'BaseTextRow',
  props: {
    row: Object,
    center: Boolean
  },
  computed: {
    textSizes () {
      const opts = {
        s: 'md:text-xl',
        r: 'text-lg md:text-2xl',
        l: 'text-xl md:text-3xl'
      }
      const pick = this.row.size || 'r'

      return opts[pick]
    },
    indentation () {
      if (this.row.indentation) {
        return `indent-${this.row.indentation}`
      } else {
        return ''
      }
    }
  }
}
</script>

<style lang="stylus" scoped>

  .indent-allExceptFirst >>> p:nth-child(n+2)
    text-indent: 1.5em

  .indent-all >>> p
    text-indent: 1.5em

  .indent-first >>> p:first-child
    text-indent: 1.5em

  >>> a
    padding-bottom: 2px
    border-bottom: 1px solid

  >>> ol
    margin-left: 1em

    li
      padding-left: 0.5em

</style>
